import {JanglSelectController as controller} from './controller.js';
import templateUrl from './template.html';

export const janglSelectComponent = {
    templateUrl: templateUrl,
    controller: controller,
    bindings: {
        // pass in a refernce to the form form the parent for validation.
        form: '=',
        // label to use for the field
        label: '@',
        // model to bind
        model: '=',
        // element name
        name: '@',
        // options collection in format [{key: '', value: ''}]
        options: '<',
        // whether the field should be required, this will not be tested, unless validate is true
        required: '<',
        // Hide label
        hideLabel: '<',
        // flag to set whether the form should validate or not.
        validate: '<',
        // flag to set if the select should be disabled or not.
        disabled: '<',
        // flag to allow an empty option
        emptyOption: '<',
    }
};



// WEBPACK FOOTER //
// ./app/jangl/jangl-select/component.js